"use client";

import Image from "next/image";

const points = [
  "Education Can't bring Employability without experience with Employers.",
  "Can't be Enjoyable with the pressure of Memorization for Grades,",
  "Can't be Exciting without the attainment of Meaningful Milestones.",
  "Education can nurture responsibility with the Freedom to make mistakes and improve.",
  "Can bring creativity with the self-space to think and create.",
  "Can't bring togetherness without the practice of collaboration.",
  "Education can't bring life-readiness without challenging the zone of self-comfort.",
];

export default function RedefiningLearning() {
  return (
    <section className="bg-[#081E2D] py-8 md:py-16">
      <div className="page-container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              <span className="text-[#00AEEF]">At Medhavi,</span>
           <br></br>
            <span className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
              We redefine the learning <br className="hidden md:block" />{" "}
              experience & outcomes. 
              </span>
            <br></br>
             <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FFA201] mb-8">
              We believe,
              </span>
            </h2>

            <ul className="space-y-6">
              {points.map((point, index) => (
                <li key={index} className="flex items-start gap-4 m-2">
                  <span className="mt-1 shrink-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <p className="text-sm md:text-base lg:text-lg font-medium opacity-90">
                    {point}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Image */}
          <div className="relative aspect-[4/3] overflow-hidden shadow-2xl">
            <Image
              src="https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Skills-in-higher-education.jpg" // Placeholder or actual image if known
              alt="Medhavi Learning Experience"
              fill
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
